import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/about")({
  head: () => pageHead({ title: 'About Us', description: 'Learn about Rex & Sons RVs, a family-owned RV dealership serving Wilmington and Castle Hayne, NC since 1997.', path: '/about' }),
  beforeLoad: () => {
    throw redirect({ href: "/about-us" });
  },
});
